<app-header [childValue]="selectedLang" (valueChanged)="onChildValueChanged($event)"></app-header>

<div class="sticky-bar menu-section">
  <p-menubar [model]="items"></p-menubar>
</div>

<div class="w3-hover-shadow w3-borderB mt-1 mb-1">
  <div class="p-fluid p-formgrid justify-content-center my-0"
    style="display: flex; align-items: center; flex-wrap: wrap;">
    <div class="field sm:col-12 md:col-12 lg:col-12 my-0 py-0 mx-0 px-2" style="display: flex; align-items: center;">
      <!-- Static text on the left -->
      <div class="marquee-static-text">
        <!-- <p> {{ 'FARMER_CORNER' | translate }} &nbsp;&nbsp;&nbsp; {{ 'NEW_TARGET_FOR_TANK_INFO' | translate }}</p> -->
        <p> {{ 'FARMER_CORNER' | translate }}</p>
      </div>
      <!-- Marquee text -->
      <div class="marquee-text" style="flex: 1; overflow: hidden;">
        <marquee direction="left" onmouseover="this.stop();" onmouseout="this.start();" scrollamount="4">
          <span class="s1"><img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> {{ 'PORTAL_OPEN_SOON' | translate }}</span> &nbsp;&nbsp;&nbsp;&nbsp;
          <!-- <span class="s1"><img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> {{ 'NEW_TARGET_FOR_TANK_INFO' | translate }}</span> &nbsp;&nbsp;&nbsp;&nbsp; -->
          <!-- <span class="s2">{{ 'MARQUEE_TEXT_LANDING_PAGE' | translate }}</span> -->
        </marquee>
      </div>
    </div>
  </div>

  <div class="p-fluid p-formgrid justify-content-center mt-2 mb-0" style="display: flex; flex-wrap:wrap">
    <!-- <div class="p-fluid p-formgrid justify-content-center top-header-sec" style="display: flex; flex-wrap:wrap"> -->
    <div class="field md:col-12 col-0 my-0 py-0 mx-0 px-0">
      <!-- Button Section -->
      <div class="login-button-section d-flex">
        <button pButton class="button-33" type="button" (click)="onClickLogin('farmer-stp')">
          <a><b>{{ 'STP/TWW_BASED_MI' | translate }}</b></a>
        </button>
        <button pButton class="button-33" type="button" (click)="onClickLogin('farmer-overflow-pond')">
          <a><b>{{ 'OVERFLOW_POND_BASED_MI' | translate }}</b></a>
        </button>
        <button pButton class="button-33" type="button" (click)="onClickLogin('farmer-canal')">
          <a><b>{{ 'CANAL_BASED_MI' | translate }}</b></a>
        </button>
        <button pButton class="button-33" type="button" (click)="onClickLogin('farmer-tubewell')">
          <a><b>{{ 'TUBEWELL_BASED_MI' | translate }}</b></a>
        </button>
        <!-- <button pButton class="button-33" type="button" (click)="onClickLogin('login')">
        <a><b>{{ 'LOGIN' | translate }}</b></a>
      </button> -->
        <!-- <button pButton class="button-33" type="button" (click)="menu.toggle($event)">
        <a><b>{{ 'FARMER_LOGIN' | translate }}</b></a>
      </button> -->
        <!-- <button pButton class="button-33" type="button" [ngStyle]="{'font-size': '0.75rem'}"><a
        [routerLink]="['/vendor-registration-login']"><b>{{ 'VENDOR_REGISGTRATION'|translate}}</b></a></button> -->
        <button pButton class="button-33" type="button" [ngStyle]="{'font-size': '0.6rem'}"
          (click)="onClickLogin('noc')">
          <a><b>{{ 'APPLY_FOR_NOC(MI)' | translate }}</b></a>
        </button>
      </div>
    </div>
  </div>
</div>


<div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap; position: relative;">

  <!-- Content Overlay -->
  <div class="banner-content-overlay hide-small mt-2">
    <!-- <div class="p-fluid p-formgrid justify-content-left" style="display: flex; flex-wrap:wrap"> -->
      <div class="container-leader">
        <div class="d-flex-leader align-items-center" *ngFor="let person of leaders">
          <div class="image-container-leader">
            <img [src]="person.image" alt="Leader Image" class="rounded-circle" />
          </div>
    
          <div class="text-box-leader">
            <div class="text-box-leader-content">
              <h5 class="mb-1">{{ person.name }}</h5>
              <p class="mb-1">{{ person.title }}</p>
              <p class="location">{{ person.location }}</p>
            </div>
          </div>
        </div>
      </div>
    <!-- </div> -->
    <!-- <h2>Your Heading Here</h2>
    <p>Your description or other content goes here. Add as much content as needed, and it will adapt to the height of the banner.</p>
    <button style="padding: 10px 20px; background-color: #007bff; color: white; border: none; border-radius: 5px; cursor: pointer;">Call to Action</button> -->
  </div>

  <!-- <div class="new-registration hide-small mt-2 flex justify-content-end">
    <p><img src="../../../assets/activitiesImages/newitem.gif" alt="New Item">{{ 'VENDOR_RE_INFO' | translate }}</p>
  </div> -->

  <!-- Banner Section -->
  <p-galleria [value]="bannerScrollerImages" [responsiveOptions]="responsiveOptions"
    [containerStyle]="{'max-width': '100%'}" [numVisible]="5" [showThumbnails]="false" [showIndicators]="true"
    [changeItemOnIndicatorHover]="true" [autoPlay]="true" [transitionInterval]="3000" [circular]="true"
    [showItemNavigators]="false">
    <ng-template pTemplate="item" let-item>
      <div class="top-level-image d-flex">
        <img [src]="item.previewImageSrc"
          style="padding-top:5px; padding-bottom:5px; width: 100%; height: auto; object-fit: fill;" />
        <p>{{ item.description }}</p>
      </div>
    </ng-template>
  </p-galleria>
</div>

<!-- <div class="card mt-2 new-registration-small-scr d-flex justify-content-center w3-hide-medium w3-hide-large" style="display: flex; flex-wrap:wrap">
  <p><img src="../../../assets/activitiesImages/newitem.gif" alt="New Item">{{ 'VENDOR_RE_INFO' | translate }}</p>
</div> -->

<div class="p-fluid p-formgrid justify-content-left w3-hide-medium  w3-hide-large" style="display: flex; flex-wrap:wrap">
  <div class="my-0 py-0 container-leader w3-hover-shadow w3-borderB">
    <div class="d-flex-leader align-items-center" *ngFor="let person of leaders">
      <div class="image-container-leader">
        <img [src]="person.image" alt="Leader Image" class="rounded-circle" />
      </div>

      <div class="text-box-leader">
        <div class="text-box-leader-content">
          <h5 class="mb-1">{{ person.name }}</h5>
          <p class="mb-1">{{ person.title }}</p>
          <p class="location">{{ person.location }}</p>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- <div
    class="field sm:col-12 md:col-0 lg:col-0 my-0 py-0 px-0 mx-0 w3-hover-shadow w3-borderB w3-container w3-center events-links-container">
    <ul class="w3-ul w3-margin-top" style="font-size:12px;">
      <li class="w3-large w3-padding-16 events-links-header"><b>{{'NEWS_AND_EVENTS'|
          translate}}</b></li>
      <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" scrollamount="3"
        style="max-height: 250px;">
        <li class="w3-padding-16 w3-left-align"><b>{{'FARMER_ONLINE_APPLICATION_FOR_MI'| translate}}</b><br>
          <p>{{'FARMER_ONLINE_APPLICATION_HAS_BEEN_INAUGURATED'| translate}}</p>
        </li>

        <li class="w3-padding-16  w3-left-align"><b>{{'CADA_CHIEF_ENGINEER'| translate}}</b><br>
          {{'SH_SURESH_YADAV'| translate}}</li>

        <li class="w3-padding-24 w3-left-align"></li>
        <li class="w3-padding-16 w3-left-align"></li>
      </marquee>
    </ul>
  </div> -->


<!-- <div #targetSection1 class="row p-0 mt-4 lg:mt-0 grid">
  <div class="admin-name col-12 md:col-4 lg:col-4" style="text-align: center;">
    <img src="../../../assets/activitiesImages/ir_min.jpeg" style="width:150px;height:130px; border-radius: 50%;">
    <p style="font-size:16px; color:rgb(8, 145, 179);"><b>{{'IR_MIN_NAME'| translate}}<p
          style="font-size:12px; color:black; font-weight:bold">{{'IRRIGATION_MINISTER'| translate}}<br>
          {{'HARYANA'| translate}}</p></b></p>
  </div>
  <div class="admin-name col-12 md:col-4 lg:col-4" style="text-align: center;">
    <img src="../../../assets/activitiesImages/chief_sec.jpg" style="width:150px;height:130px; border-radius: 50%;">
    <p style="font-size:16px; color:rgb(8, 145, 179)"><b>{{'CHIEF_SEC_NAME'| translate}}<p
          style="font-size:12px; color:black; font-weight:bold">{{'ADD_CHIEF_SEC'| translate}}<br>
          {{'HARYANA'| translate}}</p></b></p>
  </div>
  <div class="admin-name col-12 md:col-4 lg:col-4" style="text-align: center;">
    <img src="../../../assets/activitiesImages/admin.jpg" style="width:150px;height:130px; border-radius: 50%;">
    <p style="font-size:16px; color:rgb(8, 145, 179)"><b>{{'DR_SATBIR_SINGH'| translate}}<p
          style="font-size:12px; color:black; font-weight:bold">{{'ENGINNER_IN_CHIEF'| translate}}<br>
          {{'ADMINISTRATOR'| translate}}<br>
          {{'CADA_HARYANA'| translate}}</p></b></p><br>
  </div>
</div> -->


<!-- <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
  <div class="field md:col-8 col-12">
    <p-galleria [value]="images" [responsiveOptions]="responsiveOptions"
      [containerStyle]="{'max-width': '100%', 'height': '100%'}" [numVisible]="5" [showThumbnails]="false"
      [showIndicators]="true" [changeItemOnIndicatorHover]="true" [autoPlay]="true" [transitionInterval]="3000"
      [circular]="true">
      <ng-template pTemplate="item" let-item>
        <img [src]="item.previewImageSrc" style="width: 100%; height: 350px; display: block;" />
      </ng-template>
      <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
          <img [src]="item.thumbnailImageSrc" style="display: block;" />
        </div>
      </ng-template>
    </p-galleria>
  </div>
  <div class="field md:col-4 col-12">
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/BPIuROHR2eI?autoplay=1&mute=1&loop=1&playlist=BPIuROHR2eI"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
  </div>
</div> -->
<!-- <div class="w3-col m10 w3-margin-top top-container1" style="width: 60%; height: 100%; display: block;">
  <div class="w3-container">
    <p-galleria [value]="images" [responsiveOptions]="responsiveOptions"
      [containerStyle]="{'max-width': '100%', 'height': '100%'}" [numVisible]="5" [showThumbnails]="false"
      [showIndicators]="true" [changeItemOnIndicatorHover]="true" [autoPlay]="true" [transitionInterval]="3000"
      [circular]="true">
      <ng-template pTemplate="item" let-item>
        <img [src]="item.previewImageSrc" 
             style="width: 100%; height: 350px; display: block; object-fit: contain;" />
      </ng-template>
      <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
          <img [src]="item.thumbnailImageSrc" style="display: block; object-fit: cover;" />
        </div>
      </ng-template>
    </p-galleria>
  </div>
</div> -->

<div #targetSection2 class="p-fluid p-formgrid justify-content-center mt-2 mb-0" style="display: flex; flex-wrap:wrap">
  <div class="w3-col m2 w3-container info-container1 w3-center w3-hover-shadow w3-border events-links-container">
    <ul class="w3-ul w3-margin-top" style="font-size:12px;">

      <li class="w3-large w3-padding-16 events-links-header"><b>{{'QUICK_LINKS'|
          translate}}</b></li>
      <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" scrollamount="3"
        style="max-height: 300px; overflow-y: auto;">
        <li class="w3-padding-8 cursor-pointer-new w3-left-align">
          <a [routerLink]="['/vendor-registration-login']" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'VENDOR_REGISTRATION' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer-new w3-left-align">
          <a href="assets/home/landing-page-doc/Registration Terms & Conditions.pdf" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'VENDOR_REGISTRATION_TERMS_AND_CONDITIONS' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer-new w3-left-align">
          <a href="assets/home/landing-page-doc/amended120625.pdf" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'AMENDED_TERMS_AND_CONDITIONS_AND_ANNEXURE' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer-new w3-left-align">
          <a href="assets/home/landing-page-doc/Corrigendum 2nd dated 19.06.2025.pdf" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'CORRIGENGUM_2ND' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer-new w3-left-align">
          <a href="assets/home/landing-page-doc/Corrigendum 3rd dated 19.06.2025.pdf" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'CORRIGENGUM_3RD' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="assets/home/landing-page-doc/Quality of engineering works.pdf" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'QUALITY_OF_ENGINEERING_WORKS' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="assets/home/landing-page-doc/TRANSPARENCY & ACTUAL PHYSICAL INSTALLATION PROTOCAL.pdf"
            target="_blank" style="text-decoration: none; color: inherit;">
            {{ 'TRANSPARENCY_&_ACTUAL_PHYSICAL_INSTALLATION_PROTOCAL' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="http://cada.hartron.io/assets/home/adv042024.pdf" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'LANDING_PAGE_POST_ADVERTISEMENT' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <!-- <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="https://www.cadaharyana.nic.in/PDMCDoc.pdf" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'UNSUCCESS_PAYMENT' | translate }}
          </a>
        </li> -->
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="https://www.cadaharyana.nic.in/MIVendor/Farmer_Vendor_Login.aspx" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'VENDOR_LOGIN' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="http://cada.hartron.io/assets/home/waterpolicy2122.pdf" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'WATER_POLICY' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="https://www.cadaharyana.nic.in/Farmer_Application/MIscheme.aspx" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'FARMER_ONLINE_APP_WEB_PORTAL_FOR_MI' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="http://cada.hartron.io/assets/home/On%20Farm%20Water%20Tank%20Policy%20Final-%202020-21.pdf"
            target="_blank" style="text-decoration: none; color: inherit;">
            {{ 'ON_FARM_WATER_TANK_POLICY' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="http://cada.hartron.io/assets/home/Guidelines%20MI.pdf" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'IMPLEMENTATION_GUIDELINES' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="https://micadaharyana.nic.in/MICircular.aspx" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'MI_CIRCULAR' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a href="http://cada.hartron.io/assets/home/AarogyaSetuIVRS.pdf" target="_blank"
            style="text-decoration: none; color: inherit;">
            {{ 'AAROGYA_SETU_IVRS' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>
        <li class="w3-padding-8 cursor-pointer w3-left-align">
          <a (click)="onClickHeader('newTarget')" style="text-decoration: none; color: inherit;">
            {{ 'QUICK_LINK_NEW_TARGET' | translate }}
            <!-- <img src="../../../assets/activitiesImages/newitem.gif" alt="New Item"> -->
          </a>
        </li>

        <li class="w3-padding-8  w3-left-align">MICADA PORTAL से सम्बंधित योजनाओ की जानकारी हेतु आप हेल्पलाइन संख्या
          0172 - 2800610 पर 9.00 AM to 5.00 PM संपर्क कर सकते है</li>
      </marquee>
    </ul>
  </div>

  <!-- <div #targetSection3 class="col-12 w3-container info-container2 w3-center"> -->
  <div class="w3-col m8 w3-container info-container2 w3-center w3-hover-shadow w3-border">
    <ul *ngIf="showHome" class="w3-ul w3-margin-top" style="font-size:12px;">
      <h5 style="font-size:18px; color:black; font-weight:bold">{{'WELCOME_TO_MICADA'| translate}}</h5>

      <h4 style="color:#020202; background:#d3e1e7;" class="px-3"><b>{{'ABOUT_CADA'| translate}}</b></h4>

      <p style="font-size:13px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
        <!-- <b>{{'ABOUT_CADA_DETAILS'| translate}}</b>
      </p> -->
      <p style="font-size:13px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
        <b>{{'ABOUT_CADA_DETAILS'| translate}}<br>
          <br>
          {{'POINT_1'| translate}}<br>
          {{'POINT_2'| translate}}<br>
          {{'POINT_3'| translate}}<br>
          {{'POINT_4'| translate}}<br>
          {{'POINT_5'| translate}}</b>
      </p><br>
      <!-- <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3"><b>{{'ORGANIZATIONAL_SETUP'|
          translate}}</b></h5>
      <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
        <b>{{'THE_OVERALL_CONTROL_OF_CADA'| translate}}<br>
          {{'MEMBER_1'| translate}}<br>
          {{'MEMBER_2'| translate}}<br>
          {{'MEMBER_3'| translate}}<br>
          {{'MEMBER_4'| translate}}<br>
          {{'MEMBER_5'| translate}}<br>
          {{'MEMBER_6'| translate}}<br>
          {{'MEMBER_7'| translate}}<br>
          {{'MEMBER_8'| translate}}<br>
          {{'MEMBER_9'| translate}}<br>
          {{'MEMBER_10'| translate}}<br>
          {{'MEMBER_11'| translate}}<br>
          {{'MEMBER_12'| translate}}<br>
          {{'MEMBER_13'| translate}}<br>
          {{'MEMBER_14'| translate}}</b>
      </p><br> -->
    </ul>

    <app-activities *ngIf="showActivities"></app-activities>
    <app-office-orders *ngIf="showOfficeOrders"></app-office-orders>
    <app-statistics *ngIf="showStatistics"></app-statistics>
    <app-rti *ngIf="showRti"></app-rti>
    <app-new-initiatives *ngIf="showNewInitiatives"></app-new-initiatives>
    <app-organizational-setup *ngIf="showOrgSetup"></app-organizational-setup>
    <app-beneficiary-details *ngIf="showBenDetails"></app-beneficiary-details>
    <app-achievements *ngIf="showAchievements"></app-achievements>
    <app-micro-irrigation *ngIf="showMicroIrrigation"></app-micro-irrigation>
    <app-annual-plan *ngIf="showAnnualPlan"></app-annual-plan>
    <app-evaluation-study *ngIf="showEvaluationStudy"></app-evaluation-study>
    <app-new-target *ngIf="showNewTarget"></app-new-target>
    <app-project *ngIf="showProject"></app-project>
    <app-key-executives *ngIf="showFieldExecutives"></app-key-executives>
    <app-head-off-executives *ngIf="showHeadOffExecutives"></app-head-off-executives>
  </div>

  <div class="w3-col m2 w3-container info-container3 w3-center w3-hover-shadow w3-border events-links-container">
    <ul class="w3-ul w3-margin-top" style="font-size:12px;">

      <li class="w3-large w3-padding-16 events-links-header"><b>{{'NEWS_AND_EVENTS'|
          translate}}</b></li>
      <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" scrollamount="3"
        style="max-height: 300px;">
        <li class="w3-padding-16 w3-left-align"><b>{{'FARMER_ONLINE_APPLICATION_FOR_MI'| translate}}</b><br>
          <p>{{'FARMER_ONLINE_APPLICATION_HAS_BEEN_INAUGURATED'| translate}}</p>
        </li>

        <li class="w3-padding-24 w3-left-align"></li>
        <li class="w3-padding-16 w3-left-align"></li>
      </marquee>
    </ul>
  </div>
</div>

<!-- <div #targetSection1 class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
  <div class="gallery-area field md:col-6 col-12">
    <div class="p-fluid p-formgrid justify-content-left" style="display: flex; flex-wrap:wrap;">
      <div class="field col-12 md:col-6 my-0 mx-0 py-0 px-0">
        <p class="text-center pt-3">{{ 'IMAGE_GALLERY' | translate}}</p>
      </div>
      <div class="field col-12 md:col-6 my-0 mx-0 pb-1 px-0">
        <p-dropdown [options]="galleryFilterList" [(ngModel)]="selectedImageFilter"
          placeholder="{{'FILTER_IMAGE'| translate}}" optionLabel="label" optionValue="value"
          (onChange)="onSelectFilter()" [showClear]="true">
        </p-dropdown>
      </div>
    </div>
    <div class="custom-scroll" style="max-height: 400px; overflow-y: auto; padding: 10px;"
      (mouseover)="pauseScroll('photo')" (mouseout)="resumeScroll('photo')" #photoGallery>
      <div class="grid grid-nogutter">
        <div *ngFor="let item of images; let index = index;" class="md:col-12 col-12 py-1"
          style="display: flex; justify-content: center;">
          <div class="px-2 photo-section w3-hover-shadow w3-borderB">
            <p-image class="" (click)="imageClick(index)" [src]="item.previewImageSrc" alt="Image" width="100%"
              [preview]="false"></p-image>
            <span>{{ item.description }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="gallery-area field md:col-6 col-12">
    <div class="p-fluid p-formgrid justify-content-left" style="display: flex; flex-wrap:wrap;">
      <div class="field col-12 md:col-6 my-0 mx-0 py-0 px-0">
        <p class="text-center pt-3">{{ 'VIDEO_GALLERY' | translate}}</p>
      </div>
      <div class="field col-12 md:col-6 my-0 mx-0 pb-1 px-0">
        <p-dropdown [options]="galleryFilterList" [(ngModel)]="selectedVideoFilter"
          placeholder="{{'FILTER_VIDEO'| translate}}" optionLabel="label" optionValue="value"
          (onChange)="onSelectFilter()" [showClear]="true">
        </p-dropdown>
      </div>
    </div>
    <div class="custom-scroll"
      style="max-height: 400px; overflow-y: auto; padding: 10px; border: 1px solid #ccc; border-radius: 8px;"
      (mouseover)="pauseScroll('video')" (mouseout)="resumeScroll('video')" #videoGallery>
      <div class="grid grid-nogutter">
        <div *ngFor="let video of videos" class="md:col-12 col-12 py-1" style="display: flex; justify-content: center;">
          <div class="px-2 video-section w3-hover-shadow w3-borderB">
            <video class="" style="margin-bottom: 2px; border-radius: 2px; width: 100%; height: auto; object-fit: fill;"
              controls muted loop id="myVideo" [src]="video.url" type="video/mp4">
            </video>
            <span>{{ video.description }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->


<!-- <div class="grid col-12 md:col-12 lg:col-12 p-0 mt-4 lg:mt-0 pl-5" style="width:100%;">
  <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2 dropdown">
    <div class="px-3" style="
          height: 160px;
          padding: 2px;
          border-radius: 10px;
          background: linear-gradient(
              90deg,
              rgba(253, 228, 165, 0.2),
              rgba(187, 199, 205, 0.2)
            ),
            linear-gradient(
              180deg,
              rgba(253, 228, 165, 0.2),
              rgba(187, 199, 205, 0.2)
            );
        ">
      <a class="p-3 h-full" style="border-radius: 8px">
        <div class="flex align-items-center justify-content-center bg-yellow-200 mb-3"
          style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
          <i class="pi pi-fw pi-money-bill text-2xl text-yellow-700"></i>
        </div>
        <h5 class="mb-2 text-900">{{'FARMER_SHARE_PAYMENT'| translate}}</h5>
        <div class="dropdown-content">
          <a href="assets/home/farmer_share_payment_s1.pdf" target="_blank">{{'FARMER_SHARE_LOT_1'| translate}}</a>
          <a href="assets/home/farmer_share_payment_s2.pdf" target="_blank">{{'FARMER_SHARE_LOT_2'| translate}}</a>
          <a href="assets/home/farmer_share_payment_s3.pdf" target="_blank">{{'FARMER_SHARE_LOT_3'| translate}}</a>
          <a href="assets/home/farmer_share_payment_s4.pdf" target="_blank">{{'FARMER_SHARE_LOT_4'| translate}}</a>
          <a href="assets/home/farmer_share_payment_s5.pdf" target="_blank">{{'FARMER_SHARE_LOT_5'| translate}}</a>
        </div>
      </a>
    </div>
  </div>

  <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2">
    <div class="px-3" style="
          height: 160px;
          padding: 2px;
          border-radius: 10px;
          background: linear-gradient(
              90deg,
              rgba(145, 226, 237, 0.2),
              rgba(251, 199, 145, 0.2)
            ),
            linear-gradient(
              180deg,
              rgba(253, 228, 165, 0.2),
              rgba(172, 180, 223, 0.2)
            );
        ">
      <a a class="cursor-pointer" (click)="onClickHeader('evaluationStudy')" class="p-3  h-full"
        style="border-radius: 8px">
        <div class="flex align-items-center justify-content-center bg-cyan-200 mb-3"
          style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
          <i class="pi pi-fw pi-palette text-2xl text-cyan-700"></i>
        </div>
        <h5 class="mb-2 text-900">{{'EVALUATION_STUDY'| translate}}</h5>
      </a>
    </div>
  </div>

  <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5 mt-4 lg:mt-0">
    <div class="px-3" style="
          height: 160px;
          padding: 2px;
          border-radius: 10px;
          background: linear-gradient(
              90deg,
              rgba(145, 226, 237, 0.2),
              rgba(172, 180, 223, 0.2)
            ),
            linear-gradient(
              180deg,
              rgba(172, 180, 223, 0.2),
              rgba(246, 158, 188, 0.2)
            );
        ">
      <a class="cursor-pointer" (click)="onClickHeader('microIrrigation')" class="p-3 h-full"
        style="border-radius: 8px">
        <div class="flex align-items-center justify-content-center bg-indigo-200"
          style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
          <i class="pi pi-fw pi-map text-2xl text-indigo-700"></i>
        </div>
        <h5 class="mb-2 text-900">{{'MICRO_IRRIGATION'| translate}}</h5>
      </a>
    </div>
  </div>

  <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2">
    <div class="px-3" style="
          height: 160px;
          padding: 2px;
          border-radius: 10px;
          background: linear-gradient(
              90deg,
              rgba(187, 199, 205, 0.2),
              rgba(251, 199, 145, 0.2)
            ),
            linear-gradient(
              180deg,
              rgba(253, 228, 165, 0.2),
              rgba(145, 210, 204, 0.2)
            );
        ">
      <a a class="cursor-pointer" (click)="onClickHeader('project')" class="p-3 h-full" style="border-radius: 8px">
        <div class="flex align-items-center justify-content-center bg-bluegray-200 mb-3"
          style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
          <i class="pi pi-fw pi-id-card text-2xl text-bluegray-700"></i>
        </div>
        <h5 class="mb-2 text-900">{{'PROJECTS'| translate}}</h5>
      </a>
    </div>
  </div>

  <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5  mt-4 lg:mt-0">
    <div class="px-3" style="
          height: 160px;
          padding: 2px;
          border-radius: 10px;
          background: linear-gradient(
              90deg,
              rgba(187, 199, 205, 0.2),
              rgba(246, 158, 188, 0.2)
            ),
            linear-gradient(
              180deg,
              rgba(145, 226, 237, 0.2),
              rgba(160, 210, 250, 0.2)
            );
        ">
      <a class="cursor-pointer" (click)="onClickHeader('annualPlan')" class="p-3 h-full" style="border-radius: 8px">
        <div class="flex align-items-center justify-content-center bg-orange-200 mb-3"
          style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
          <i class="pi pi-fw pi-star text-2xl text-orange-700"></i>
        </div>
        <h5 class="mb-2 text-900">{{'ANNUAL_PLAN'| translate}}</h5>
      </a>
    </div>
  </div>

  <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5  mt-4 lg:mt-0">
    <div class="px-3" style="
    height: 160px;
    padding: 2px;
    border-radius: 10px;
    background: linear-gradient(
        90deg,
        rgba(251, 199, 145, 0.2),
        rgba(246, 158, 188, 0.2)
      ),
      linear-gradient(
        180deg,
        rgba(172, 180, 223, 0.2),
        rgba(212, 162, 221, 0.2)
      );">
      <a class="cursor-pointer" (click)="onClickHeader('achievements')" class="p-3 h-full" style="border-radius: 8px">
        <div class="flex align-items-center justify-content-center bg-orange-200 mb-3"
          style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
          <i class="pi pi-fw pi-star text-2xl text-orange-700"></i>
        </div>
        <h5 class="mb-2 text-900">{{'ACHIEVEMENTS'| translate}}</h5>
      </a>
    </div>
  </div>
</div> -->


<div class="p-fluid p-formgrid justify-content-center mx-0 gap-5 py-2 gallery-container"
  style="display: flex; flex-wrap:wrap;">
  <div
    class="card shadow-sm photo-gallery-section field sm:col-12 md:col-5 lg:col-5 my-0 py-0 px-0 mx-3 w3-hover-shadow w3-borderB text-center">
    <!-- <div class="photo-gallery-section" style="border: none;"> -->
    <!-- <img src="../../../assets/home/resize/resized_image_2.jpg" alt="Photo Gallery" class="img-fluid rounded"> -->
    <div class="custom-scroll" style="max-height: 300px; overflow-y: auto; padding: 10px;"
      (mouseover)="pauseScroll('photo')" (mouseout)="resumeScroll('photo')" #photoGallery>
      <div class="grid grid-nogutter">
        <div *ngFor="let item of images; let index = index;" class="md:col-12 col-12 py-1"
          style="display: flex; justify-content: center;">
          <div class="px-2 photo-section w3-hover-shadow w3-borderB">
            <img class="" (click)="imageClick(index)" [src]="item.previewImageSrc" alt="Image" width="100%" loading="lazy">
            <span>{{ item.description }}</span>
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-warning mt-3 w-100 clickable-text button-34 blick-text" (click)="onPhotoGalleryClick()">{{
      'MORE_PHOTOS' | translate }}
      →</button>
    <!-- </div> -->
  </div>
  <div
    class="card shadow-sm video-gallery-section field sm:col-12 md:col-5 lg:col-5 my-0 py-0 px-0 mx-3 w3-hover-shadow w3-borderB text-center">
    <!-- <div class="card shadow-sm video-gallery-section" style="border: none;"> -->
    <!-- <div class="p-fluid p-formgrid justify-content-left" style="display: flex; flex-wrap:wrap;">
        <div class="field col-12 md:col-6 my-0 mx-0 py-0 px-0">
          <p class="text-center pt-3">{{ 'VIDEO_GALLERY' | translate}}</p>
        </div>
        <div class="field col-12 md:col-6 my-0 mx-0 pb-1 px-0">
          <p-dropdown [options]="galleryFilterList" [(ngModel)]="selectedVideoFilter"
            placeholder="{{'FILTER_VIDEO'| translate}}" optionLabel="label" optionValue="value"
            (onChange)="onSelectFilter()" [showClear]="true">
          </p-dropdown>
        </div>
      </div> -->
    <div class="custom-scroll"
      style="max-height: 300px; overflow-y: auto; padding: 10px; border: 1px solid #ccc; border-radius: 8px;"
      (mouseover)="pauseScroll('video')" (mouseout)="resumeScroll('video')" #videoGallery>
      <div class="grid grid-nogutter">
        <div *ngFor="let video of videos" class="md:col-12 col-12 py-1" style="display: flex; justify-content: center;">
          <div class="px-2 video-section w3-hover-shadow w3-borderB video-responsive">
            <div class="video-iframe-wrapper">
              <iframe
                loading="lazy"
                [src]="(video.url + '?autoplay=0&mute=1&enablejsapi=1') | safeUrl"
                frameborder="0"
                allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                title="YouTube video"
              ></iframe>
            </div>
            <span>{{ video.description }}</span>
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-warning mt-3 w-100 clickable-text button-34 blick-text" (click)="onVideosClick()">{{ 'MORE_VIDEOS' |
      translate }}
      →</button>
    <!-- </div> -->
  </div>
</div>

<!-- <div class="w3-row-padding bottom-content mt-0 pt-2" id="plans">
  <div class="w3-third w3-margin-bottom w3-margin-top">
    <ul class="w3-ul w3-border w3-center w3-hover-shadow bottom-content-box" style="height: 300px; overflow-y: auto;">
      <li class="w3-large w3-padding-32 sticky-header bottom-content-box-header">
        <b>{{ 'UPCOMING_PROJECTS' | translate }}</b>
      </li>
    </ul>
  </div>

  <div class="w3-third w3-margin-bottom w3-margin-top ">
    <ul class="w3-ul w3-border w3-center w3-hover-shadow bottom-content-box" style="height: 300px; overflow-y: auto;">
      <li class="w3-large w3-padding-32 sticky-header bottom-content-box-header">
        <b>{{ 'ON_GOING_PROJECTS' | translate }}</b>
      </li>
      <li class="w3-padding-16">{{ 'STP/TWW Project Based MI Systems' | translate }}</li>
      <li class="w3-padding-16">{{ 'Overflow Pond Project Based MI Systems' | translate }}</li>
      <li class="w3-padding-16">{{ 'Canal Project Based MI Systems' | translate }}</li>
      <li class="w3-padding-16">{{ 'Tubewell Based MI Systems' | translate }}</li>
      <li class="w3-padding-16">{{ 'EPC Project Based MI Systems' | translate }}</li>
    </ul>
  </div>

  <div class="w3-third w3-margin-bottom w3-margin-top">
    <ul class="w3-ul w3-border w3-center w3-hover-shadow bottom-content-box" style="height: 300px; overflow-y: auto;">
      <li class="w3-large w3-padding-32 sticky-header bottom-content-box-header">
        <b>{{ 'IMPORTANT_LINKS' | translate }}</b>
      </li>
      <li class="w3-padding-16 w3-text-blue"><a href="http://hrcada.attendance.gov.in/"
          target="_blank">http://hrcada.attendance.gov.in/</a></li>
      <li class="w3-padding-16 w3-text-blue"><a href="http://lmshry.gov.in/" target="_blank">http://lmshry.gov.in/</a>
      </li>
      <li class="w3-padding-16 w3-text-blue"><a href="https://etenders.hry.nic.in/nicgep/app"
          target="_blank">https://etenders.hry.nic.in/nicgep/app</a></li>
      <li class="w3-padding-16 w3-text-blue"><a href="http://hrmshry.nic.in/" target="_blank">http://hrmshry.nic.in/</a>
      </li>
      <li class="w3-padding-16 w3-text-blue"><a href="https://pgportal.gov.in/"
          target="_blank">https://pgportal.gov.in/</a></li>
    </ul>
  </div>
</div> -->

<div #targetSection5>

</div>
<app-footer></app-footer>

<!-- <footer class="w3-container w3-center" style="background:#112f4e;height:120px; color:white;">
  <div class="w3-row-padding">
    <div class="w3-center w3-bar-item" style="margin-bottom:5px; color:white;">
      <p><b><strong>{{'MICADA_HARYANA'| translate}}</strong></b><br><b>
          {{'BAYS_39_40_SECTOR_4_PANCHKULA'| translate}}<br>
          {{'FAX_NO'| translate}}<br>
          {{'EMAIL'| translate}}:hrcada@chd.nic.in</b></p>
      <p class="w3-hide-medium w3-hide-small" style="color:white;"><b>
          Copyright © 2021 Micro Irrigation &
          Command Area Development Authority, Haryana. All Rights Reserved.</b>
      </p>
    </div>
  </div>
</footer> -->

<p-galleria [value]="images" [(visible)]="displayImages" [(activeIndex)]="activeIndex"
  [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
  [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
  <ng-template pTemplate="item" let-item>
    <div class="photo-section-zoom">
      <img [src]="item.previewImageSrc" />
      <span>{{ item.description }}</span>
    </div>
  </ng-template>
</p-galleria>